import { Component, Input } from '@angular/core';

export enum LogoColor {
  WHITE = '#fff',
  BLACK = '#000',
}

@Component({
  selector: 'app-aaptiv-logo',
  standalone: true,
  templateUrl: './logo.component.html',
})
export class LogoComponent {
  @Input() width!: string;
  @Input() height!: string;
  @Input() fill = LogoColor.WHITE;
}
